module.exports = __webpack_public_path__ + "img/gambia.c86fc64b.svg";